import { Component, Input, signal, WritableSignal, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'chubb-tabs',
  standalone: true,
  imports: [ CommonModule ],
  templateUrl: './chubb-tabs.component.html',
  styleUrl: './chubb-tabs.component.scss'
})
export class ChubbTabsComponent {
  @Input() labels: Array<{value: string, label: string, shortLabel?: string}> = [];
  @Input() active: WritableSignal<number> = signal(0);

  readonly tabClick = output<{index:number, label: string, value: string}>();

  changeTab(index: number, tab: {value: string, label: string}): void {
    this.tabClick.emit({index, label: tab.label, value: tab.value});
  }
}
